var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/cards/status/offer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3333333,19 C10.7013333,19 11,19.2986667 11,19.6666667 L11,19.6666667 L11,21.3333333 C11,21.7013333 10.7013333,22 10.3333333,22 L10.3333333,22 L7.66666667,22 C7.29866667,22 7,21.7013333 7,21.3333333 L7,21.3333333 L7,19.6666667 C7,19.2986667 7.29866667,19 7.66666667,19 L7.66666667,19 Z M22.3333333,19 C22.7013333,19 23,19.2986667 23,19.6666667 L23,19.6666667 L23,21.3333333 C23,21.7013333 22.7013333,22 22.3333333,22 L22.3333333,22 L13,22 C12.632,22 12.3333333,21.7013333 12.3333333,21.3333333 L12.3333333,21.3333333 L12.3333333,19.6666667 C12.3333333,19.2986667 12.632,19 13,19 L13,19 Z M10.3333333,13 C10.7013333,13 11,13.2986667 11,13.6666667 L11,13.6666667 L11,15.3333333 C11,15.7013333 10.7013333,16 10.3333333,16 L10.3333333,16 L7.66666667,16 C7.29866667,16 7,15.7013333 7,15.3333333 L7,15.3333333 L7,13.6666667 C7,13.2986667 7.29866667,13 7.66666667,13 L7.66666667,13 Z M22.3333333,13 C22.7013333,13 23,13.2986667 23,13.6666667 L23,13.6666667 L23,15.3333333 C23,15.7013333 22.7013333,16 22.3333333,16 L22.3333333,16 L13,16 C12.632,16 12.3333333,15.7013333 12.3333333,15.3333333 L12.3333333,15.3333333 L12.3333333,13.6666667 C12.3333333,13.2986667 12.632,13 13,13 L13,13 Z M10.3333333,7 C10.7013333,7 11,7.29866667 11,7.66666667 L11,7.66666667 L11,9.33333333 C11,9.70133333 10.7013333,10 10.3333333,10 L10.3333333,10 L7.66666667,10 C7.29866667,10 7,9.70133333 7,9.33333333 L7,9.33333333 L7,7.66666667 C7,7.29866667 7.29866667,7 7.66666667,7 L7.66666667,7 Z M22.3333333,7 C22.7013333,7 23,7.29866667 23,7.66666667 L23,7.66666667 L23,9.33333333 C23,9.70133333 22.7013333,10 22.3333333,10 L22.3333333,10 L13,10 C12.632,10 12.3333333,9.70133333 12.3333333,9.33333333 L12.3333333,9.33333333 L12.3333333,7.66666667 C12.3333333,7.29866667 12.632,7 13,7 L13,7 Z",
    id: "icon'",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.4e3710bd.svg";
export { ForwardRef as ReactComponent };